// extracted by mini-css-extract-plugin
export default {"select":"Select_select__HP7GS","body":"Select_body__Kmt4r","show":"Select_show__0Dwat","link":"Select_link__JIhd-","register":"Select_register__aZsKF"};